namespace TabAurous.OMS {

    @Serenity.Decorators.registerEditor()
    export class MetalRateEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);
            this.addOption("Gram", "Gram");
            this.addOption("Troy Ounce", "Troy Ounce");
        }
    }
}